import { RecipeSelectionRoot, RecipeIcon, Highlight, RecipeWrapper } from './RecipeSelection.styles'
import { Icon } from 'components/Icon'
import Link from 'next/link'
import { Proteins } from 'models/Pet'
import { IconName } from 'components/Icon/iconNames'

type RecipeDataType = {
  href: string
  variant: Proteins
  icon: IconName
}

const recipeData: RecipeDataType[] = [
  { href: '/products/5-lb-chicken-patty-recipe', variant: Proteins.CHICKEN, icon: 'chicken' },
  { href: '/products/5-lb-beef-patty-recipe', variant: Proteins.BEEF, icon: 'cow' },
  { href: '/products/5-lb-lamb-patty-recipe', variant: Proteins.LAMB, icon: 'lamb' },
  { href: '/products/5-lb-turkey-patty-recipe', variant: Proteins.TURKEY, icon: 'turkey' },
  { href: '/products/5-lb-venison-patty-recipe', variant: Proteins.VENISON, icon: 'deer' },
  { href: '/products/5-lb-duck-patty-recipe', variant: Proteins.DUCK, icon: 'duck' },
]

type RecipeSelectionProps = {
  className?: string
  recipe?: Proteins
}

export const RecipeSelection = ({ className, recipe }: RecipeSelectionProps) => (
  <RecipeSelectionRoot className={className}>
    {recipeData.map(({ href, variant, icon }) =>
      recipe === variant ? (
        <RecipeWrapper key={href}>
          <Highlight>
            <RecipeIcon variant={variant}>
              <Icon color="accent-white" name={icon} />
            </RecipeIcon>
          </Highlight>
        </RecipeWrapper>
      ) : (
        <Link key={href} href={href}>
          <RecipeWrapper>
            <RecipeIcon variant={variant}>
              <Icon color="accent-white" name={icon} />
            </RecipeIcon>
          </RecipeWrapper>
        </Link>
      )
    )}
  </RecipeSelectionRoot>
)
